import { filterToQueryParams } from '../utils';
import { request } from '../request';
import { Filter } from '@libs/store/filters';
import { PaginatedResponse } from '@libs/models/common';
import { ShiftTypePresetListItem } from '@libs/models/shiftTemplates';

export type GetTimecardsParams = {
  orderBy?: { key: string; sort: string }[];
  search?: string;
  page?: number;
  size?: number;
  filters?: Record<string, Filter>;
};
export async function fetchShiftTypePresetsList(
  params?: GetTimecardsParams,
): Promise<PaginatedResponse<ShiftTypePresetListItem[]>> {
  const filters = filterToQueryParams(params?.filters ?? {}, {
    removeEmpty: true,
    renameMap: { qualifications: 'nurseQualifications' },
  });
  const response = await request.get<ListItemResponse[]>('/v2/templates/time-presets', {
    params: {
      search: filters?.search_in ?? params?.search,
      ...filters,
    },
  });
  return {
    items: response.data.map((item) => ({
      ...item,
    })),
    pageNumber: 0,
    pageSize: 0,
    totalCount: response.data.length,
  };
}

type ListItemResponse = {
  id: string; // 'shifttimepresettemplate-00000000000000000000000000';
  name: string;
  startTime: string; // '00:00:00';
  durationInSeconds: number;
  isReadonly: boolean;
  location: {
    id: string; // 'location-00000000000000000000000000';
    name: string;
  };
};
